import {
  REMOVECREATETIMEENT,
  MODIFYCREATEDTIMEENT,
  MODIFYCLIENTNAMEENT,
  FILTERSITETMAP,
  MODIFYSITENAMEENT,
  FILTERDATEMAP,
  FILTERCLIENTMAP
} from '@nile/reports/src/modules/charts/constants';
import { getTranslatedText } from '@nile/components';
import produce from 'immer';
import { cloneDeep, groupBy, isArray, isEmpty } from 'lodash';

const preFormatFilterObject = (props) => {
  const { entity, filterObj, removeLabel = false } = props;
  let operands = {};
  let reportCondition = cloneDeep(filterObj);
  if (reportCondition && entity && REMOVECREATETIMEENT.includes(entity)) {
    reportCondition = reportCondition.filter(
      (el) => el.attribute !== 'createdTime'
    );
    if (!reportCondition.length) reportCondition = null;
  }

  if (reportCondition && entity) {
    operands = produce(reportCondition, (draft) => {
      draft.map((item) => {
        if (removeLabel) {
          delete item.label;
        }
        if (
          item.attribute === 'createdTime' &&
          MODIFYCREATEDTIMEENT.includes(entity)
        ) {
          item.attribute = FILTERDATEMAP[entity] || item.attribute;

          // if (item.attribute === 'computedDate' && isArray(item.value)) {
          //   item.value[0] = dayjs(item.value[0]).format(DATE_FORMAT);
          //   item.value[1] = dayjs(item.value[1])
          //     .endOf('month')
          //     .format(DATE_FORMAT);
          // }
        }
        if (
          item.attribute === 'client' &&
          MODIFYCLIENTNAMEENT.includes(entity)
        ) {
          item.attribute = FILTERCLIENTMAP[entity] || item.attribute;
        }
        if (item.attribute === 'site' && MODIFYSITENAMEENT.includes(entity)) {
          item.attribute = FILTERSITETMAP[entity] || item.attribute;
        }
      });
    });
  }
  return { operands, reportCondition };
};

const getGlobalEntityAttributes = (intl, meta, ntt) => {
  if (!meta) {
    return [];
  }

  const customAttributes = meta || [];

  const getEntityAttribute = (ent) => {
    const res =
      customAttributes.find((item) => {
        return item.name === ent;
      })?.attributes || [];
    return res;
  };

  const getAllFilteredAttributes = (ent, type) => {
    return getEntityAttribute(ent)?.filter((attr) => attr[type]);
  };

  const getAttributes = (item, ent) => {
    if (item.dataType !== 'entity') {
      return { ...item, moduleEntity: ent };
    }
    return getAllFilteredAttributes(item.entity, 'useInGroupBy')
      .map((at) => {
        if (at.dataType === 'entity') {
          return getAttributes(at, at?.entity).map((subItem) => {
            return {
              ...subItem,
              name: `${item.name}.${subItem.name}`,
              moduleEntity: at?.entity || null
            };
          });
        }
        return {
          ...at,
          name: `${item.name}.${at.name}`,
          moduleEntity: item?.entity || null
        };
      })
      .flat();
  };

  const groupByAttributes = ntt
    .map((el) => {
      return getAllFilteredAttributes(el, 'useInGroupBy')
        .map((attr) => getAttributes(attr, el))
        .flat();
    })
    .flat();

  const groupAttributes = Object.entries(
    groupBy(groupByAttributes, 'moduleEntity')
  ).map(([key, value]) => ({
    label: key,
    options:
      !isEmpty(value) &&
      value.map((el) => ({
        ...el,
        value: el?.attributePlaceHolder?.label
          ? el?.isCustom
            ? el?.attributePlaceHolder?.label
            : getTranslatedText(intl, el?.attributePlaceHolder?.label)
          : '',
        label: el?.attributePlaceHolder?.label
          ? el?.isCustom
            ? el?.attributePlaceHolder?.label
            : getTranslatedText(intl, el?.attributePlaceHolder?.label)
          : ''
      }))
  }));

  const metricAttributes = ntt
    .map((el) => getAllFilteredAttributes(el, 'useInMetric'))
    .map((attr) =>
      attr.dataType === 'entity'
        ? getAllFilteredAttributes(attr.entity, 'useInMetric').map((at) => ({
            ...at,
            name: `${attr.name}.${at.name}`
          }))
        : attr
    )
    .flat();

  return { groupByAttributes, groupAttributes, metricAttributes };
};

export { getGlobalEntityAttributes, preFormatFilterObject };
